"use client";
import * as React from "react";
const SvgExpandLessFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 8", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m6 .3-6 6 1.41 1.4L6 3.14l4.59 4.58L12 6.3z" }));
export {
  SvgExpandLessFilled as default
};
